<template>
  <div class="about">
		<div class="pg-header">
			<div><label class="title">无意向</label></div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>签约管理</span>|
					<span>无意向</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<el-tabs class="customize" v-model="filter.schedulingState">
				<el-tab-pane label="无意向" name="1"></el-tab-pane>
			</el-tabs>
					
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>姓名<el-input size="small" maxlength="6" style="width:80px" v-model.trim="filter.name" @keyup.enter.native="handleFilter(0, $event)"></el-input></label>
						<label>身份证号<el-input size="small" maxlength="18" style="width:150px" v-model.trim="filter.cardNum" @keyup.enter.native="handleFilter(1, $event)"></el-input></label>
						
						<el-button class="flr" size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<!-- <div class="action-bar">
					<el-popconfirm confirmButtonText='确定' title="确定勿访吗？" @confirm="saveForm">
						<el-button slot="reference" type="danger" size="mini" round plain>批量勿访</el-button>
					</el-popconfirm>
				</div> -->
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<!-- <el-table-column fixed="left" type="selection" width="55"></el-table-column> -->
					<el-table-column prop="name" label="姓名" width="120">
						<template slot-scope="scope"><router-link class="noline" target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3, fid: scope.row.recordId,datasources:scope.row.datasources,t2:2}}"><span class="fc key"><i class="icon-fav small" v-if="scope.row.star == 1"></i>{{ scope.row.name }}</span></router-link></template>
					</el-table-column>
					<el-table-column label="性别" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.sex == 1">男</span>
							<span v-else>女</span>
						</template>
					</el-table-column>
					<el-table-column prop="age" label="年龄" width="80">
						<template slot-scope="scope">
							<span>{{scope.row.age}}岁</span>
						</template>
					</el-table-column>
					<el-table-column prop="nation" label="民族" width="80"></el-table-column>
					<el-table-column prop="cardNum" label="身份证号"></el-table-column>
					<el-table-column prop="phone" label="联系电话"></el-table-column>
					<el-table-column prop="date" label="更新时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="160">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="查看" placement="top" :enterable="false"><router-link target="_blank" :to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3, fid: scope.row.recordId,datasources:scope.row.datasources,t2:2}}"><i class="icon-research"></i></router-link></el-tooltip>
								<!-- <el-tooltip content="排期" placement="top" :enterable="false"><i class="icon-schedule" @click="scope"></i></el-tooltip> -->

								<el-tooltip content="签约" placement="top" :enterable="false">
									<i class="icon-custom"  @click="showDlg(scope.row)">
									<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="19" height="17.933425903320312" viewBox="0 0 19 17.933425903320312"><g style="mix-blend-mode:passthrough"><g><g style="mix-blend-mode:passthrough"><path d="M0.77981,16.2018L0.77981,1.42809C0.77981,1.07042,1.07094,0.77981,1.42809,0.77981L13.5988,0.77981C13.9565,0.77981,14.2476,1.07094,14.2476,1.42809L14.2476,8.21972L15.0275,8.21972L15.0275,1.42809C15.0275,0.640484,14.387,1.44294e-16,13.5988,1.44294e-16L1.42809,0C0.640484,0,0,0.640484,0,1.42809L0,16.2018C0,16.9895,0.640484,17.6299,1.42809,17.6299L8.63249,17.6299L8.63249,16.8501L1.42809,16.8501C1.07042,16.8501,0.77981,16.5595,0.77981,16.2018Z" fill-opacity="1"/></g><g style="mix-blend-mode:passthrough"><g><g style="mix-blend-mode:passthrough"><path d="M17.576648000793455,8.494466191711426C16.913088000793458,8.317633191711426,16.205638000793456,8.509256991711426,15.722038000793457,8.996812191711426L10.600878000793458,14.117766191711425C10.574828000793456,14.143796191711425,10.554958000793457,14.175346191711427,10.542748000793457,14.210086191711426L9.533412500793457,17.083126191711425C9.355945000793458,17.587896191711426,9.841472000793457,18.073416191711424,10.346240000793458,17.896156191711427L13.219898000793457,16.886626191711425C13.254548000793458,16.874446191711428,13.286018000793458,16.854646191711424,13.312008000793456,16.828696191711426L18.43296800079346,11.707736191711426C18.920518000793457,11.224146191711426,19.112138000793458,10.516686191711425,18.935308000793455,9.853126191711425C18.758478000793456,9.189573191711427,18.240198000793455,8.671299191711427,17.576648000793455,8.494466191711426ZM17.077528000793457,8.926602191711426C17.455648000793456,8.926602191711426,17.81826800079346,9.076807191711426,18.08563800079346,9.344172191711426C18.352998000793455,9.611536191711426,18.503208000793457,9.974166191711426,18.503208000793457,10.352276191711425C18.503208000793457,10.730386191711425,18.352998000793455,11.093016191711426,18.08563800079346,11.360376191711426L13.004178000793457,16.44162619171143L10.183747000793456,17.432736191711427C10.130614000793457,17.451466191711425,10.071450000793456,17.438026191711426,10.031614000793457,17.398196191711428C9.991778000793458,17.358356191711426,9.978344000793458,17.299196191711424,9.997069000793458,17.246056191711425L10.987978000793458,14.425626191711427L16.069428000793458,9.344172191711426C16.336798000793458,9.076807191711426,16.699418000793457,8.926602191711426,17.077528000793457,8.926602191711426Z" fill-rule="evenodd" fill-opacity="1"/></g><g style="mix-blend-mode:passthrough"><path d="M15.532251470222473,9.678842622718811C15.436351470222473,9.583062622718812,15.280991470222473,9.583062622718812,15.185091470222474,9.678842622718811C15.089181470222474,9.77476562271881,15.089181470222474,9.930280622718811,15.185091470222474,10.02620362271881L17.407421470222474,12.24873762271881C17.469301470222472,12.311627622718811,17.560161470222475,12.33650762271881,17.645451470222472,12.31389762271881C17.730731470222473,12.291297622718812,17.797341470222474,12.224687622718811,17.819951470222474,12.13939762271881C17.842551470222475,12.054117622718811,17.817681470222475,11.96325762271881,17.754781470222472,11.901377622718812L15.532251470222473,9.678842622718811ZM10.954172470222472,14.01105762271881C10.888979470222473,14.01105762271881,10.826461470222473,14.036977622718812,10.780389470222474,14.08309762271881L10.780798770222473,14.08309762271881C10.684882370222473,14.179027622718811,10.684882370222473,14.33453762271881,10.780798770222473,14.430457622718812L13.003131470222474,16.65299762271881C13.065011470222473,16.71588762271881,13.155861470222472,16.74076762271881,13.241151470222473,16.718157622718813C13.326441470222473,16.69555762271881,13.393051470222474,16.62894762271881,13.415651470222473,16.54365762271881C13.438261470222473,16.45836762271881,13.413381470222474,16.36750762271881,13.350491470222472,16.305637622718812L11.127954470222473,14.08309762271881C11.081882470222473,14.036977622718812,11.019364470222474,14.01105762271881,10.954172470222472,14.01105762271881Z" fill-rule="evenodd" fill-opacity="1"/></g></g></g><g style="mix-blend-mode:passthrough"><path d="M12.313200350570678,3.9801490547943117C12.313200350570678,3.7649210547943115,12.138500350570679,3.590244054794312,11.92330035057068,3.590244054794312L2.192305350570679,3.5902440547943115C1.9770773505706787,3.5902440547943115,1.8024003505706787,3.7649210547943115,1.8024003505706787,3.9801490547943117C1.8024003505706787,4.195376054794312,1.9770773505706787,4.370054054794312,2.192305350570679,4.370054054794312L11.922800350570679,4.370054054794312C12.138500350570679,4.370054054794312,12.313200350570678,4.195896054794312,12.313200350570678,3.9801490547943117Z" fill-opacity="1"/></g><g style="mix-blend-mode:passthrough"><path d="M9.540710350570679,7.852164769439697C9.540710350570679,7.636936769439697,9.366030350570679,7.462259769439697,9.15081035057068,7.462259769439697L2.192305350570679,7.462259769439697C1.9770773505706787,7.462259769439697,1.8024003505706787,7.636936769439697,1.8024003505706787,7.852164769439697C1.8024003505706787,8.067391769439697,1.9770773505706787,8.242069769439697,2.192305350570679,8.242069769439697L9.150290350570678,8.242069769439697C9.366030350570679,8.242069769439697,9.540710350570679,8.067391769439697,9.540710350570679,7.852164769439697Z" fill-opacity="1"/></g><g style="mix-blend-mode:passthrough"><path d="M2.192305350570679,11.35766887664795C1.9770773505706787,11.35766887664795,1.8024003505706787,11.53234587664795,1.8024003505706787,11.74757387664795C1.8024003505706787,11.962800876647949,1.9770773505706787,12.137478876647949,2.192305350570679,12.137478876647949L6.378320350570679,12.137478876647949C6.593550350570679,12.137478876647949,6.768230350570679,11.962800876647949,6.768230350570679,11.74757387664795C6.768230350570679,11.53234587664795,6.593550350570679,11.35766887664795,6.378320350570679,11.35766887664795L2.192305350570679,11.35766887664795Z" fill-opacity="1"/></g></g></g></svg>
									</i>
								</el-tooltip>

								<el-popconfirm confirmButtonText='回退' title="确定回退到待签约吗？" @confirm="saveForm2(scope.row)">
									<el-tooltip content="回退" slot="reference" placement="top" :enterable="false">
										<i class="icon-sync"></i>
									</el-tooltip>
								</el-popconfirm>
							</div>
						</template>
					</el-table-column>
				</el-table>	
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>				
				

			<el-dialog title="签约" width="560px" center :visible.sync="dlg.active" :close-on-click-modal="false">
				<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
					<el-form-item label="签约周期：" prop="period">
						<el-date-picker type="daterange" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy/MM/dd" v-model="form.period"></el-date-picker>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" :loading="isLoading" @click="saveForm">保存</el-button>
				</div>
			</el-dialog>

		</div>

  </div>
</template>

<script>
import api from '@/service/api.js';
import utils from '@/service/utils';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';

export default {
  mixins: [mixin],
	data(){
		return {
			dlg: {
				active: false,
				rules: {
					period: {required: true, message: '请选择', trigger: 'change'}
				}
			},			
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				cardNum: '',
				signState: 3,
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				id: 0,
				period: undefined,
			},
		}
	},
	created() {
		// let query = this.$route.query;
		let name=localStorage.getItem('noName');
		let cardNum=localStorage.getItem('noCardNum');
		if(name||cardNum){
			this.filter.name=name;
			this.filter.cardNum=cardNum;
			this.handleFilter()
		}else{
			this.loadList()
		}
	},	
	mounted() {
		// 监听页面显示隐藏
		document.addEventListener('visibilitychange', this.handleVisiable)  
	},  
	destroyed() {
		localStorage.removeItem('noName');
		localStorage.removeItem('noCardNum');  
		document.removeEventListener('visibilitychange', this.handleVisiable)  
	},  
	methods: {
		async loadList() {
			this.isLoading = true;

			let res = await api.getContractList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
					item.cardNum = utils.hideIdCard(item.cardNum);
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
		},
		// 签约
		async saveForm() {
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					console.log('内容', this.form);
					let res, postForm;
					this.isLoading = true;
					postForm = {
						signStartTime: this.form.period[0],
						signEndTime: this.form.period[1],
						patientId: this.form.patientId,
					}
					
					res = await api.setContractSigned(postForm);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}

					this.$message.success('签约成功');
					this.closeDlg();
					this.loadList();
				}	
			});
		},
		async saveForm2(item) {
				this.isLoading = true;
				let res = await api.setContractBack({patientId: item.patientId});
				this.isLoading = false;
				if (res.code != 1000) {
					return this.$message.error(res.message);
				}
				this.$message.success('操作成功');
				this.loadList();			
		},
		showDlg(item) {
			this.dlg.active = true;
			this.$nextTick(()=>{
				this.$refs['form'].resetFields();
				console.log('签约', item);
				this.form.patientId = item.patientId;
			});
		},
		closeDlg() {
			this.dlg.active = false;
		},		
		// 过滤条件 更改
		handleFilter(key, val) {
			this.filter.pageNumber = 1;
			this.loadList();
		},
		getUser() {
			return JSON.parse(localStorage.getItem('user')).data;
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		handleVisiable(e){
			console.log(e.target.visibilityState)
			// 关闭新开页面，回到列表页，刷新列表数据
			if(e.target.visibilityState == "visible"){
				this.loadList()
			}
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
.user-not-found {
	position: absolute;
	top: 20px;
	right: 20px;
	z-index: 2;
	i {
		margin-right: 5px;
	}
}
.def-key{
	.el-checkbox{
		font-weight:400 ;
		color: #808080;
	}
}
</style>
